import type { RuntimeConfig } from '@ivs-test/contracts';

let runtimeConfig: RuntimeConfig | undefined;

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (runtimeConfig) return runtimeConfig;
  const response = await fetch('/config.json', { cache: 'no-store' });
  if (!response.ok) throw new Error(`config.json could not be loaded: ${response.status}`);
  runtimeConfig = (await response.json()) as RuntimeConfig;
  return runtimeConfig;
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!runtimeConfig) throw new Error('Runtime config is not loaded');
  return runtimeConfig;
}

